import React, { useState, useEffect, useRef } from 'react';
import { Col, Row, Nav } from 'react-bootstrap';
import { RoleManagement, UserManagement } from './';


function AdminSettings() {
    const [currentTab, setCurrentTab] = useState('user-management');
    const [showSidebar, setShowSidebar] = useState(true);
    const timeoutRef = useRef();
    useEffect(() => {
        timeoutRef.current = setTimeout(() => {
            setShowSidebar(false);
        }, 3000);
    }, []);
    const toggleSidebar = () => {
        clearTimeout(timeoutRef.current);
        setShowSidebar(!showSidebar);
    }

    return (
        <Col md={12} sm={12} className='justify-content-center' style={{ position: 'relative' }}>
            <span className={showSidebar ? 'hide-menu' : 'show-menu'} onClick={toggleSidebar}><i className={`fa ${showSidebar ? 'fa-angle-double-left' : 'fa-angle-double-right'}`}></i></span>
            <Row>
                {showSidebar && (<Col md={2} sm={12} className='left-menu-panel'>
                    <Nav className="flex-column border-bottom">
                        <small className='left-menu-hd'><i className="fa fa-line-chart"></i> User</small>
                        <Nav.Link eventKey="user-management" onClick={() => setCurrentTab('user-management')} className={`left-menu-links ${currentTab === 'user-management' ? 'active' : ''}`}> User Management</Nav.Link>
                        <Nav.Link eventKey="role-management" onClick={() => setCurrentTab('role-management')} className={`left-menu-links ${currentTab === 'role-management' ? 'active' : ''}`}> User Group Management</Nav.Link>
                    </Nav>
                    {/* <Nav className="flex-column border-bottom">
                                <small className='left-menu-hd'><i className="fa fa-bar-chart"></i> CHARTS</small>
                                <Nav.Link className='left-menu-links'>User's Statewise Analytics</Nav.Link>
                            </Nav> */}
                </Col>
                )}
                <Col md={showSidebar ? "10" : "-12"} sm={12} style={{ minHeight: '100vh' }}>
                    {/* {currentTab === 'rolewisetracking' && <Rolewisetracking />}
                    {currentTab === 'config-management' && <ConfigManagement />} */}
                    {currentTab === 'role-management' && <RoleManagement />}
                    {currentTab === 'user-management' && <UserManagement />}
                    {/* {currentTab === 'config-management' && <ConfigManagement />} */}
                </Col>
            </Row>
        </Col>
    );
}

export default AdminSettings;
